import 'url-search-params-polyfill';
import 'promise-polyfill/src/polyfill';
import * as THREE from 'three';
import {gsap, Power1, Power3} from 'gsap/all';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);
import 'lazysizes';
import objectFitImages from 'object-fit-images';
objectFitImages();

//////////////////////////////
// グローバル変数
//////////////////////////////
window.THREE = THREE;
window.gsap = gsap;
window.Power1 = Power1;
window.Power3 = Power3;
window.gTOCO = [];
window.gTOCO.rootHTML = document.documentElement;
window.gTOCO.lang = window.gTOCO.rootHTML.lang;
window.gTOCO.mods = [];
window.gTOCO.isDevice = '';
window.gTOCO.isAndroid = false;
window.gTOCO.isEnableTouch = false;
window.gTOCO.siteUrl = location.protocol + '//' + location.hostname;
if (location.port != 80) {
  window.gTOCO.siteUrl += ':' + location.port;
}

const ua = navigator.userAgent.toLowerCase();
if (/iphone|ipad|macintosh|ipod/.test(ua) && 'ontouchend' in document) {
  gTOCO.rootHTML.classList.add('toco-mobile');
  gTOCO.isDevice = 'mobile';
  gTOCO.isAndroid = false;
} else if (/android/.test(ua) && 'ontouchend' in document) {
  gTOCO.rootHTML.classList.add('toco-mobile');
  gTOCO.isDevice = 'mobile';
  gTOCO.isAndroid = true;
} else {
  gTOCO.rootHTML.classList.add('toco-pc');
  gTOCO.isDevice = 'pc';
  gTOCO.isAndroid = false;
}

if(window.ontouchstart !== undefined && 0 < navigator.maxTouchPoints) {
  gTOCO.isEnableTouch = true;
}

//history.scrollRestoration = 'manual';

window.delay = (n) => {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
};
